import { render, staticRenderFns } from "./BubbleChart.vue?vue&type=template&id=3f368d30&scoped=true&"
import script from "./BubbleChart.vue?vue&type=script&lang=js&"
export * from "./BubbleChart.vue?vue&type=script&lang=js&"
import style0 from "./BubbleChart.vue?vue&type=style&index=0&id=3f368d30&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f368d30",
  null
  
)

/* custom blocks */
import block0 from "./BubbleChart.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports